import React from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { useIntl } from 'react-intl'
import { storeGet, STORE_KEY_ACCOUNT } from 'mailup-react-helpers'

import {
  FormElement,
  InputText,
  INPUT_TEXT_VARIANT_DANGER,
  Text
} from 'mailup-web-components'

import {
  dirtyState,
  inputState,
  INPUT_VALUE_CUSTOM_URL,
  isInputInvalidState
} from 'Pages/UrlSelection/recoil/state/input'

const InputCustomUrl = () => {
  const intl = useIntl()

  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
  const isInvalid = useRecoilValue(isInputInvalidState)
  const setDirty = useSetRecoilState(dirtyState)
  const [{ url, radioValue }, setInput] = useRecoilState(inputState)

  const handleChange = e => {
    setInput(prev => ({ ...prev, isDirty: true, url: e.target.value }))
    setDirty(prev => ({ ...prev, urlDirty: true }))
  }
  // --

  return (
    <>
      {IsTrial ? (
        <Text>
          {intl.formatMessage(
            { id: 'Load.LinkUrlSelection.TrialMessage' },
            { linebreak: <br />, br: <br /> }
          )}
        </Text>
      ) : (
        <FormElement
          label={intl.formatMessage({
            id: 'Load.LinkUrlSelection.CustomLinkLabel'
          })}
          required={radioValue === INPUT_VALUE_CUSTOM_URL}
          feedback={
            isInvalid
              ? intl.formatMessage({ id: 'Load.Common.InvalidUrl' })
              : undefined
          }
          feedbackVariant={isInvalid ? 'danger' : undefined}
        >
          <InputText
            value={url}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: 'Load.LinkUrlSelection.CustomLinkPlaceholder'
            })}
            variant={isInvalid ? INPUT_TEXT_VARIANT_DANGER : undefined}
            data-mu-test='input__custom-url'
          />
        </FormElement>
      )}
    </>
  )
}

export default InputCustomUrl
